import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router';
import {bindActionCreators} from 'redux';
import {makeRequest, dispatchAction, displayMessage}  from 'actions';


class GuestLayout extends Component {

    render() {
         return (
            <div className="guest-layout">
                 <div className="container">
                     {this.props.children}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        userReducer: state.userReducer,
        // currentURL: ownProps.location
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestLayout);